import { useState } from 'react';


import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';

const localizer = momentLocalizer(moment);

const events = [
  {
    title: 'Event 1',
    start: new Date(2023, 4, 5),
    end: new Date(2023, 4, 7),
  },
  {
    title: 'Event 2',
    start: new Date(2023, 4, 8),
    end: new Date(2023, 4, 10),
  },
];

const MyCalendar = () => {
  const [selectedEvent, setSelectedEvent] = useState(null);

  const handleSelectEvent = (event) => {
    setSelectedEvent(event);
  };

  const handleSelectSlot = ({ start, end }) => {
    if (selectedEvent) {
      const updatedEvent = {
        ...selectedEvent,
        start,
        end,
      };

      moveEvent({ event: updatedEvent, start, end });
      setSelectedEvent(null);
    }
  };

  const moveEvent = ({ event, start, end, isAllDay: droppedOnAllDaySlot }) => {
    const { events } = this.state;

    const idx = events.indexOf(event);
    let allDay = event.allDay;

    if (!event.allDay && droppedOnAllDaySlot) {
      allDay = true;
    } else if (event.allDay && !droppedOnAllDaySlot) {
      allDay = false;
    }

    const updatedEvent = { ...event, start, end, allDay };

    const nextEvents = [...events];
    nextEvents.splice(idx, 1, updatedEvent);

    // Call a callback function to update the events data
    handleUpdateEvents(nextEvents);
  };

  return (
    <Calendar
      localizer={localizer}
      events={events}
      startAccessor="start"
      endAccessor="end"
      style={{ height: 500 }}
      selectable
      onSelectEvent={handleSelectEvent}
      onSelectSlot={handleSelectSlot}
    />
  );
};


export default MyCalendar
